import {
    Directive,
    Input,
    ComponentFactoryResolver,
    ViewContainerRef,
    Injector,
    SimpleChanges,
    OnChanges,
} from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';

@Directive({
    selector: '[busyIf]',
})
export class BusyIfDirective implements OnChanges {
    private static index = 0;

    @Input() busyIf: boolean;

    ngxSpinnerService: NgxSpinnerService;
    isBusy = false;

    private spinnerName = '';

    constructor(
        private _viewContainer: ViewContainerRef,
        private _appSessionService: AppSessionService,
        private _componentFactoryResolver: ComponentFactoryResolver,
        private _injector: Injector
    ) {
        this.ngxSpinnerService = _injector.get(NgxSpinnerService);
        this.loadComponent();
    }


    refreshState(): void {
        if (this.isBusy === undefined || this.spinnerName === '') {
            return;
        }

        setTimeout(() => {
            if (this.isBusy) {
                this.ngxSpinnerService.show(this.spinnerName);
            } else {
                this.ngxSpinnerService.hide(this.spinnerName);
            }
        }, 1000);
    }

    loadComponent() {
        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(NgxSpinnerComponent);
        const componentRef = this._viewContainer.createComponent(componentFactory);
        this.spinnerName = 'busyIfSpinner-' + BusyIfDirective.index++ + '-' + Math.floor(Math.random() * 1000000); // generate random name
        let component = <NgxSpinnerComponent>componentRef.instance;
        component.name = this.spinnerName;
        component.fullScreen = false;

        component.type = 'ball-clip-rotate';
        component.size = 'medium';
        var color = abp.setting.get(AppConsts.themeColorSetting);
        component.color = !color ? '#0b4171' : color;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.busyIf) {
            this.isBusy = changes.busyIf.currentValue;
            this.refreshState();
        }
    }
}
